<form [formGroup]="form" name="new-message-form" (submit)="sendMessage()">
  <div class="modal-body">
    <div class="modal-header-wrapper">
      <h2 class="title-text">Poser une question <b>{{name}}</b></h2>
    </div>
    <div id="modal-content-wrapper">
      <div id="subject-form" class="form-field">
        <label>Objet</label>
        <input type="text" [class.is-invalid]="subjectInvalid" class="form-control" id="subject-input"
          placeholder="Objet de votre message ici" formControlName="subject">
        <div class="invalid-feedback">
          Veuillez entrer un objet valide.
        </div>
      </div>
      <div id="message-form" class="form-field">
        <label>Votre message</label>
        <textarea id="message-textarea" [class.is-invalid]="messageInvalid" [minRows]="3" [maxRows]="10"
          formControlName="message" autosize placeholder="Écrivez votre message ici" type="text" class="form-control"
          aria-describedby="content"></textarea>
        <div class="invalid-feedback">
          Veuillez entrer un message valide.
        </div>
      </div>

      <div id="scheduled-date-wrapper">
        <div class="form-check form-switch">
          <input class="form-check-input" formControlName="scheduled" type="checkbox" id="scheduled-switch">
          <label class="form-check-label" for="scheduled-switch">Programmer la date et l’heure de l'envoi</label>
        </div>
      </div>
      <div id="scheduled-date-selector-wrapper" *ngIf="isScheduled">
        <div id="date-wrapper">
          <label>Date</label>
          <input id="date-input" formControlName="date" type="text" placeholder="Choisissez une date"
                 class="form-control" [bsConfig]="{ containerClass: 'theme-blue', adaptivePosition: true }"
                 bsDatepicker>
        </div>

        <div id="hour-wrapper">
          <label>Heure</label>
          <input id="hour-input" formControlName="time" type="time" placeholder="Choisissez une heure"
                 class="form-control">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal()" type="button"
      class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="send-button" type="submit" [disabled]="!isFormValid || isLoading" (click)="sendMessage()" type="button"
      class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading; else sendButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #sendButton>
        Envoyer
      </ng-template>
    </button>
  </div>
</form>
